import React from 'react';

export const SESSION_STORAGE_KEY = 'embedded-ts-web-context';
export const EmbeddableConfigContext = React.createContext();
export const contextExistsInStorage = () => !!(window.sessionStorage.getItem(SESSION_STORAGE_KEY));
export const clearSessionStorage = () => window.sessionStorage.removeItem(SESSION_STORAGE_KEY);

export default class EmbeddableConfigProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enabledFeatures: { ...this.props.workflow },
      inviteInfo: this.props.inviteInfo,
      clientRedirectURL: this.props.clientRedirectURL,
      scoringRequest: {},
      bankingConfig: {},
    };
    this.saveContextToSessionStorage = this.saveContextToSessionStorage.bind(this);
    this.restoreContextFromSessionStorage = this.restoreContextFromSessionStorage.bind(this);
  }

  storeScoringRequestToContext = (request) => this.setState({ scoringRequest: request });

  storeBankingInfoToContext = (bankingConfig) => {
    this.setState({ bankingConfig });
  };

  saveContextToSessionStorage() {
    const contextJSONStr = JSON.stringify(this.state);
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, contextJSONStr);
  }

  restoreContextFromSessionStorage() {
    const contextJSONStr = window.sessionStorage.getItem(SESSION_STORAGE_KEY);

    if (contextJSONStr) {
      const contextJSON = JSON.parse(contextJSONStr);
      this.setState({ ...contextJSON });
    }
  }

  render() {
    return (
      <EmbeddableConfigContext.Provider
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={{
          enabledFeatures: this.state.enabledFeatures,
          clientRedirectURL: this.state.clientRedirectURL,
          scoringRequest: this.state.scoringRequest,
          inviteInfo: this.state.inviteInfo,
          storeScoringRequestToContext: this.storeScoringRequestToContext,
          storeBankingInfoToContext: this.storeBankingInfoToContext,
          bankingConfig: this.state.bankingConfig,
          saveContextToSessionStorage: this.saveContextToSessionStorage,
          restoreContextFromSessionStorage: this.restoreContextFromSessionStorage,
        }}
      >
        {this.props.children}
      </EmbeddableConfigContext.Provider>
    );
  }
}
